<template>
  <div class="chartElem">
    <div class="row align-center justify-center">
      <highcharts ref="hc" class="chart" :options="chartOptions" :updateArgs="updateArgs"></highcharts>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
      _resizeObserver: null,
      cursos: [
            'Materno',
            'Niño',
            'Adolescente',
            'Joven',
            'Adulto',
            'Adulto Mayor', 
        ],
        colores: [
          '#FFB7E9', // Materno
          '#1A89C0', // Niño
          '#FF9800', // Adolescente
          '#E5D335', //Joven
          '#A3B93D',  //Adulto
          '#1DA099' //Adulto Mayor
        ],
        titulos: [
            'Cuidado Integral de la Gestante',
            'Cuidado Integral del Niño',
            'Cuidado Integral del Adolescente',
            'Cuidado Integral del Joven',
            'Cuidado Integral del Adulto',
            'Cuidado Integral del Adulto Mayor', 
        ],
        grupos: [
            'NEONATO',
            'MENOR DE 1 AÑO',
            '1 AÑO',
            '2 AÑOS',
            '3 AÑOS',
            '4 AÑOS',
            'DE 5 a 11 AÑOS',
        ],
      title: '',
      points: [10, 0, 8, 2, 6, 4, 5, 5],
      chartType: 'Spline',
      seriesColor: 'red',
      colorInputIsSupported: null,
      animationDuration: 1200,
      updateArgs: [true, true, {duration: 1200}],
      chartOptions: {
        chart: {
          polar: true,
          type: 'line',
          reflow: true,
        },
        title: {
          text: 'Cuidado Integral',
          x: 0,
          style: {
            color: 'red',
            fontWeight: 'bold'
          }
        },
        pane: {
            size: '100%'
        },

        xAxis: {
            categories: [],
            tickmarkPlacement: 'on',
            lineWidth: 0,
        },

        yAxis: {
            gridLineInterpolation: 'polygon',
            lineWidth: 0,
            min: 0,
            labels: {
                style: {
                  hidden: true,
                  color: '#FF3333',
                  fontSize: '0px'
                },
                formatter: function () {
                    return this.value + ' %';
                }
            }
        },

        plotOptions: {
            area: {
                dataLabels: {
                    enabled: true,
                    color: 'black'
                },
            },
        },

        tooltip: {
            headerFormat: '<b>{series.name}</b><br/>',
            pointFormat: '{point.category}: {point.y}%'
        },

        legend: {
            align: 'right',
            verticalAlign: 'middle',
            layout: 'vertical'
        },

        series: [{
            name: 'Cuidado Integral',
            data: [],
            color: '#33C1FF',
            pointPlacement: 'on',
            type: 'area',
            showInLegend: false,
            dataLabels: {
                enabled: true,
                color: 'black',
                borderColor: "red",
                format: '{point.y} %',
                style: {
                  fontSize: '12px'
                },
                zIndex: 6,
                allowOverlap: true,
            },
        }],

        exporting: {
            buttons: {
                contextButton: {
                    menuItems: ['viewFullscreen', 'downloadPNG', 'downloadJPEG', 'downloadPDF']
                }
            }
        },

        responsive: {
            rules: [{
                condition: {
                    maxWidth: 600,
                    maxHeight: 700
                },
                chartOptions: {
                    chart: {
                        height: 360,
                        spacing: [10, 10, 10, 10],
                    },
                    legend: {
                        align: 'center',
                        verticalAlign: 'bottom',
                        layout: 'horizontal',
                        itemStyle: {
                            fontSize: '10px'
                        }
                    },
                    pane: {
                        size: '75%'
                    },
                    xAxis: {
                        labels: {
                            style: {
                                fontSize: '9px'
                            }
                        }
                    },
                    series: [{
                        dataLabels: {
                            style: {
                                fontSize: '10px'
                            }
                        }
                    }]
                }
            }]
        }
      },
  }),
  created () {
    this.getIniciar()
  },
  mounted() {
    this.$nextTick(() => {
      if (typeof ResizeObserver !== 'undefined') {
        this._resizeObserver = new ResizeObserver(() => {
          this.reflowChart()
        })
        this._resizeObserver.observe(this.$el)
      }
      window.addEventListener('resize', this.reflowChart, { passive: true })
      this.reflowChart()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.reflowChart)
    if (this._resizeObserver) {
      this._resizeObserver.disconnect()
      this._resizeObserver = null
    }
  },
  props: {
    serie: { type: [Number, String], required: true },
    datos: { type: Array, required: true },
    categorias: { type: Array, required: true },
    grupo: { type: [Number, String], required: false, default: 0 },
    height: { type: [Number, String], required: false, default: 520 },
  },
  watch: {
    title (newValue) {
      this.chartOptions.title.text = newValue
    },
    points (newValue) {
      this.chartOptions.series[0].data = newValue
    },
    chartType (newValue) {
      this.chartOptions.chart.type = newValue.toLowerCase()
    },
    seriesColor (newValue) {
      this.chartOptions.series[0].color = newValue.toLowerCase()
    },
    animationDuration (newValue) {
      this.updateArgs[2].duration = Number(newValue)
    }
  },
  methods: {
    reflowChart() {
      const chart = this.$refs.hc && this.$refs.hc.chart
      if (chart && typeof chart.reflow === 'function') {
        chart.reflow()
      }
    },
    getIniciar() {
      this.chartOptions.title.text = 'Prueba'
      let titulo = this.titulos[this.serie-1]
      if(this.serie === 2){
        if(this.grupo === 0){
          titulo = 'CUIDADO INTEGRAL DEL ' + this.grupos[this.grupo]
        }
        else{
          titulo = titulo + ' - ' + this.grupos[this.grupo]
        }
      }
      this.chartOptions.title.text = titulo.toUpperCase()
      this.chartOptions.chart.height = Number(this.height) || 520
      this.chartOptions.xAxis.categories = this.categorias
      this.chartOptions.series[0].name = ''
      this.chartOptions.series[0].data = this.datos
      this.chartOptions.series[0].color = this.colores[this.serie-1]
      console.log(this.chartOptions.series[0].data)
      this.$nextTick(() => this.reflowChart())
    },
  }
}
</script>

<style scoped>
 .chartElem {
     width: 100%;
 }

 .chartElem .row {
     width: 100%;
 }

 .chart {
     width: 100%;
 }
</style>
